import { Archive } from '@/components/Archive'
import { Container } from '@/components/Container'
import { PopularVoteContainer } from '@/components/PopularVoteContainer'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { css } from 'styled-components/macro'
import { PageHeader } from '../../../../components/page-header'
import { Impressum } from '../../../../compositions/impressum/impressum'
import { pickMultiLocaleString } from '../../../../domain'
import { useFederalBallotsCollection, useFirestoreSnapshot, usePopularVoteDocument } from '../../../../lib'
import { useEnv } from '../../../../lib/env'
import { CenteredLoader } from '../../../../materials'
import * as firestore from 'firebase/firestore'

export interface Params {
  popularVoteId: string
}

export default (function Page() {
  const { db, intl } = useEnv()

  const params = useParams<Params>()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [params.popularVoteId])

  const { popularVoteId } = params

  const popularVoteDocument = usePopularVoteDocument(params)
  const federalBallotsCollection = useFederalBallotsCollection(params)
  const cantons = useFirestoreSnapshot(firestore.collection(db, 'popularVotes', popularVoteId, 'cantons'))

  if (!popularVoteDocument || !federalBallotsCollection || !cantons) {
    return (
      <>
        <PageHeader popularVoteId={popularVoteId} activeTab="federal" />
        <CenteredLoader />
      </>
    )
  }

  return (
    <>
      <PageHeader popularVoteId={popularVoteId} activeTab="federal" />

      <div css={styles.content as any}>
        <PopularVoteContainer
          popularVoteId={popularVoteId}
          popularVoteDocument={popularVoteDocument}
          federalBallots={federalBallotsCollection.map((doc) => ({
            id: doc.id,
            name: pickMultiLocaleString(intl, doc.data.name, '<federal ballot name>'),
            hasFinalResult: typeof doc.data.result?.accepted === 'boolean',
          }))}
        />

        <Container>
          <Archive />
        </Container>
      </div>

      <Impressum />
    </>
  )
})

const styles = {
  content: css`
    padding-block: 60px 80px;
  `,
}
